import { SITE_SETTINGS } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import {ISiteSettings} from "./interface";

export const AdminSiteSettingsService = {
  getAll: () => requests.get(`${SITE_SETTINGS}`),
  create: (params: any) => requests.post(`${SITE_SETTINGS}`, params),
};
